import React, { ReactNode } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { AiPart } from "@intelligems/ig-types";
import { Box } from "@mui/material";
import {
  FlattenedPart,
  MessageFlags,
} from "@src/features/ai/components/WorkflowEditor/execution/types";

const QA_BRANCH_TOOLTIP_DEBUG = true;
import { getParallelBranchIdFromMessageId } from "./getParallelBranchIdFromMessageId";

type DebugMessageTypeProps = {
  item: FlattenedPart;
  part: AiPart;
  children: ReactNode;
} & MessageFlags;

export const WithDebugMessages = ({
  item,
  debug,
  part,
  children,
}: DebugMessageTypeProps) => {
  const parallelBranchId = QA_BRANCH_TOOLTIP_DEBUG
    ? getParallelBranchIdFromMessageId(item.messageId)
    : null;

  return (
    <>
      {debug ? (
        <Box textAlign={"center"}>
          <IgTypography
            variant={"body2"}
            fontWeight={10}
            data-time={part.timestamp}
          >
            {item.nodeName} - {part.type}
          </IgTypography>
        </Box>
      ) : null}
      {parallelBranchId ? (
        <Box
          title={`parallelBranchId: ${parallelBranchId}`}
          sx={{ width: "100%" }}
        >
          {children}
        </Box>
      ) : (
        children
      )}
    </>
  );
};
